import { FeatureIslandMainWithCategoryWrapper } from "@/components/features/_layouts";

import { QuestionRoomAddress } from "./address";
import { QuestionRoomGeoLocation } from "./geo-location/geo-location";

import type { StandardRoomCategoriesAndManagerStore } from "../../store/categories";

type Props = {
	address: StandardRoomCategoriesAndManagerStore["address"];
};

export const QuestionRoomAddressRoot = ({ address }: Props) => {
	return (
		<FeatureIslandMainWithCategoryWrapper categoryStore={address}>
			<QuestionRoomAddress />
			<QuestionRoomGeoLocation />
		</FeatureIslandMainWithCategoryWrapper>
	);
};

QuestionRoomAddressRoot.displayName = "QuestionRoomAddressRoot";
